import { excelHeader } from "./header";
/**
 * @description 엑셀 헤더와 DB 키의 매핑 객체 (DB에 없는 데이터도 있음)
 * -> 헤더와 순서는 무관한 단순 매칭
 */
export const excelToDBKeyPairMap = {
    // [DB] product table data
    종류: "type",
    분류: "classification",
    관리코드: "product_code",
    제품명: "name",
    모델명: "model",
    사양: "spec",
    제조사: "manufacturer",
    // [DB] stock table data
    위치: "spot",
    상태: "conditions",
    재고: "stockNum",
    단가: "unit_price",
    // [DB]에 없는 데이터
    단위: "quantityUnit",
    합계: (i) => {
        return {
            formula: `I${i}*L${i}`,
        };
    },
};
const snakeToCamel = (key) => key.replace(/_([a-z])/g, (_, ch) => ch.toUpperCase());
const resolveValue = (item, key) => {
    const snakeValue = item[key];
    if (snakeValue !== undefined)
        return snakeValue;
    const camelKey = snakeToCamel(key);
    return item[camelKey];
};
export function insertServerData(sheet, data) {
    let currentRow = sheet.rowCount;
    data.forEach((item) => {
        currentRow += 1;
        const rowValues = excelHeader.map((header) => {
            const mapper = excelToDBKeyPairMap[header];
            if (typeof mapper === "function") {
                return mapper(currentRow);
            }
            if (typeof mapper === "string") {
                return resolveValue(item, mapper) ?? "";
            }
            switch (header) {
                case "제품 사진":
                    return "";
                case "스펙 사진":
                    return "";
                default:
                    return "";
            }
        });
        sheet.addRow(rowValues);
    });
}
